import React, { useEffect } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import InitComponent from './containers/InitComponent';
import {
  getFromLocalStorage,
  getUpdatedRefreshToken,
  setToLocalStorage,
} from './global/helpers';
import useRefreshToken from './global/hooks/useRefreshToken';
import { Chat2Desk } from './global/integrations/сhat2Desk';
import { selectors as loginSelectors } from './containers/LoginPage/reducer';

const App = () => {
  const ru = require('./global/translations/ru.json');

  useEffect(() => {
    if (!getFromLocalStorage('lang')) {
      setToLocalStorage('lang', 'ru');
    }
  }, []);

  useRefreshToken(() => {
    getUpdatedRefreshToken();
  }, []);

  i18n.use(initReactI18next).init({
    resources: {
      ru,
    },
    lng: getFromLocalStorage('lang'),
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false,
    },
  });

  useEffect(() => {
    const skyRoot = document.getElementById('wt-sky-root');
    if (skyRoot) {
      skyRoot.remove();
    }
  }, []);

  return (
    <Router>
      <Switch>
        <InitComponent />
      </Switch>
    </Router>
  );
};

export default Sentry.withProfiler(App);
